export default __webpack_public_path__ + "static/media/estufa.42c6be04.PNG";